import React from 'react';
import { Box } from '@mui/material';
import { FONT_SIZES } from '../../Theme';

export const headerFacetLinkButtonSx = {
  appearance: 'none',
  border: 0,
  background: 'transparent',
  m: 0,
  p: 0,
  font: 'inherit',
  fontSize: FONT_SIZES.bodySm,
  fontWeight: 400,
  lineHeight: 1.25,
  color: 'text.primary',
  textAlign: 'left',
  cursor: 'pointer',
  borderRadius: 0.5,
  transition: 'color 140ms ease',
  '&:hover': {
    color: 'primary.main',
    textDecoration: 'underline',
  },
  '&:focus-visible': {
    outline: (theme) => `2px solid ${theme.palette.primary.main}`,
    outlineOffset: 2,
  },
};

/**
 * Vertical list of facet link buttons used in header mega-menus.
 */
export default function HeaderFacetLinkList({
  items,
  onSelect,
  testIdPrefix,
  listSx,
  buttonSx = headerFacetLinkButtonSx,
}) {
  return (
    <Box
      component="ul"
      sx={{
        m: 0,
        p: 0,
        listStyle: 'none',
        display: 'flex',
        flexDirection: 'column',
        ...listSx,
      }}
    >
      {items.map((item) => (
        <Box component="li" key={item.value || item.label}>
          <Box
            component="button"
            type="button"
            data-testid={`${testIdPrefix}-${item.value || 'any'}`}
            onClick={() => onSelect(item.value)}
            sx={buttonSx}
          >
            {item.label}
          </Box>
        </Box>
      ))}
    </Box>
  );
}
